/*
 * @Description: 直播课堂
 */
import { RouteRecordRaw } from 'vue-router'
import Layout from '@/layout/pcHome.vue'
const inspectopenRouter: Array<RouteRecordRaw> = [
    {
        path: '/inspectopen',
        component: Layout,
        redirect: '/inspectopen/classroomLive',
        children: [
            {
                path: 'classRoomStatisticsCourseList',
                component: () => import(/* webpackChunkName: "StatisticsCourseList" */ '@/views/liveClassroom/classroomStatistics/courseList.vue'),
                name: 'classRoomStatisticsCourseList',
                meta: { title: '基于课表教室巡课详情' }  
            },
            {
                path: 'classroomLive',
                component: () => import(/* webpackChunkName: "ClassroomLive" */ '@/views/inspectopen/classroomLive/index.vue'),
                name: 'ClassroomLive',
                meta: { title: '实时教室巡课' }
            },
            {
                path: 'multiview',
                component: () => import(/* webpackChunkName: "Multiview" */ '@/views/inspectopen/multiview/index.vue'),
                name: 'Multiview',
                meta: { title: '实时教室多画面' }
            },
            {
                path: 'historyClassroomLive',
                component: () => import(/* webpackChunkName: "HistoryClassroomLive" */ '@/views/inspectopen/historyClassroomLive/index.vue'),
                name: 'HistoryClassroomLive',
                meta: { title: '历史教室巡课' }
            },
            {
                path: 'historyMultiview',
                component: () => import(/* webpackChunkName: "HistoryMultiview" */ '@/views/inspectopen/historyMultiview/index.vue'),
                name: 'HistoryMultiview',
                meta: { title: '历史教室巡课多画面' }
            },
            {
                path: 'synchronousData',
                component: () => import(/* webpackChunkName: "SynchronousData" */ '@/views/inspectopen/synchronousData/index.vue'),
                name: 'SynchronousData',
                meta: { title: '同步数据' }
            },
        ]
    }
]

export default inspectopenRouter
